import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";
//New
import Courrier from "@/pages/dossier/new/Courrier.vue";
import Autosaisine from "@/pages/dossier/new/Autosaisine.vue";
import CallCenter from "@/pages/dossier/new/CallCenter.vue";
import DossierJour from "@/pages/dossier/new/DossierJour.vue";
import ShowDossier from "@/pages/dossier/ShowDossier.vue";
import Rapports from "@/pages/dossier/rapport/Rapports.vue";


// Stats
import Statistique from "@/pages/dossier/stats/Statistique.vue";

//Liste
import Filter from "@/pages/dossier/liste/Filter.vue";


export default   {
    path: "/dossier",
    name: "Dossier",
    component: AppLayoutAdmin,
    meta: { requiredAuth: true },
    children: [
        {
            path: 'courrier',
            name: "DossierNewCourrier",
            component: Courrier,

        },
        {
            path: ':id/show',
            name: "DossierShow",
            component: ShowDossier,

        },
        {
            path: 'autosaisine',
            name: "DossierNewAutosaisine",
            component: Autosaisine
        },
        {
            path: 'callcenter',
            name: "DossierNewCallCenter",
            component: CallCenter
        },
        {
            path: 'to_follow_up',
            name: "DossierNewDossierJour",
            component: DossierJour
        },
        {
            path: 'statistiques',
            name: "DossierStatsStatistique",
            component: Statistique
        },
        {
            path: 'rapports',
            name: "DossierStatsRapport",
            component: Rapports
        },
        {
            path: 'liste/:filter',
            name: "DossierListFilter",
            component: Filter
        },
        
    ]
}